import { render } from "./WalkThrough.vue?vue&type=template&id=3554491b&scoped=true"
import script from "./WalkThrough.vue?vue&type=script&lang=js"
export * from "./WalkThrough.vue?vue&type=script&lang=js"

import "./WalkThrough.vue?vue&type=style&index=0&id=3554491b&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-iframe-br/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3554491b"]])

export default __exports__